import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { IOsaExecucaoCustoEquipeModel } from './../../../../../models/osa-execucao-custo-equipe.model';
import { OsaExecucaoCustoEquipeService } from './../../../../../services/osa-execucao-custo-equipe.service';
import Swal from 'sweetalert2';
import { BaseFormComponent } from './../../../../../shared/components/base-form/base-form.component';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { ToastrService } from 'ngx-toastr';
import { OsaExecucaoAbaCustosRecursosEquipeCustosFormModalComponent } from '../osa-execucao-aba-custos-recursos-equipe-custos-form-modal/osa-execucao-aba-custos-recursos-equipe-custos-form-modal.component';

@Component({
  selector: 'app-osa-execucao-aba-custos-recursos-equipe-custos-list',
  templateUrl: './osa-execucao-aba-custos-recursos-equipe-custos-list.component.html',
  styleUrls: ['./osa-execucao-aba-custos-recursos-equipe-custos-list.component.scss']
})
export class OsaExecucaoAbaCustosRecursosEquipeCustosListComponent extends BaseFormComponent implements OnInit {
  @Input() visualizar = false;
  @Input() secaoId = 1;
  @Output() subtotalChange = new EventEmitter<number>();
  @Input() permiteIncluir: boolean = false;

  modelOsaExecucaoCustoEquipe: IOsaExecucaoCustoEquipeModel = {} as IOsaExecucaoCustoEquipeModel;

  osaExecucaoCustoEquipeDataSource = new MatTableDataSource<IOsaExecucaoCustoEquipeModel>();
  osaExecucaoCustoEquipeSemDados = false;

  displayedColumns: string[] = [
    'nomeAgente',
    'dataInicio',
    'dataFim',
    'diasCorridos',
    'salario',
    'custoFinal',
    'actions'
  ];

  constructor(
    route: ActivatedRoute,
    toastr: ToastrService,
    router: Router,
    localeService: BsLocaleService,
    private osaExecucaoCustoEquipeService: OsaExecucaoCustoEquipeService,
    public matDialog: MatDialog,
  ) {
    super(route, toastr, router, localeService, matDialog);
  }

  ngOnInit(): void {
    this.carregarCustos();
  }

  ngOnChanges(): void {
    const total = this.calcularSubtotal();
    this.subtotalChange.emit(total);
  }

  public async carregarCustos() {
    try {
      this.osaExecucaoCustoEquipeService.obterPorExecucao(this.id, this.secaoId).then((res) => {
        if (res.sucesso) {
          this.osaExecucaoCustoEquipeDataSource = new MatTableDataSource<IOsaExecucaoCustoEquipeModel>
            (
              res.dados
            );
          this.osaExecucaoCustoEquipeDataSource._updateChangeSubscription();
          this.modelOsaExecucaoCustoEquipe = {} as IOsaExecucaoCustoEquipeModel;
          this.osaExecucaoCustoEquipeSemDados = res.dados.length != 0 ? false : true;
        } else {
          this.submit = false;
          Swal.fire({
            toast: true,
            position: 'top-end',
            icon: 'error',
            text: res.mensagem.descricao,
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
          });
          this.router.navigate(['/osaExecucao']);
          return;
        }
      });
    } catch (err) {
      this.submit = false;
      Swal.fire({
        toast: true,
        position: 'top-end',
        icon: 'error',
        text: err.mensagem?.descricao,
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
      });
      this.router.navigate(['/osaExecucao']);
    }
  }

  incluir(): void {
    try {
      const dados = {
        id: 0,
        osaExecucaoId: this.id,
        nomeAgente: '',
        dataInicio: '',
        dataFim: '',
        diasCorridos: 0,
        salario: 0,
        custoFinal: 0,
        secaoId: this.secaoId,
        secaoDescricao: ''
      } as IOsaExecucaoCustoEquipeModel

      const dialogConfig = new MatDialogConfig();
      dialogConfig.id = 'modal-component';
      dialogConfig.width = '650px';
      dialogConfig.hasBackdrop = true;
      dialogConfig.disableClose = true;
      dialogConfig.data = {
        ...dados,
        registrosExistentes: this.osaExecucaoCustoEquipeDataSource.data
      };
      const modal = this.matDialog.open(
        OsaExecucaoAbaCustosRecursosEquipeCustosFormModalComponent,
        dialogConfig
      );

      modal.afterClosed().subscribe(res => {
        if (res === true) {
          this.carregarCustos();
        }
      });
    } catch (err) {
      Swal.fire({
        toast: true,
        position: 'top-end',
        icon: 'warning',
        text: err.mensagem?.descricao,
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
      });
    }
  }

  editar(item: IOsaExecucaoCustoEquipeModel): void {
    try {
      const dados = {
        ...item,
        dataInicio: item.dataInicio ? new Date(item.dataInicio) : null,
        dataFim: item.dataFim ? new Date(item.dataFim) : null,
      };

      const dialogConfig = new MatDialogConfig();
      dialogConfig.id = 'modal-component';
      dialogConfig.width = '650px';
      dialogConfig.hasBackdrop = true;
      dialogConfig.disableClose = true;
      dialogConfig.data = dialogConfig.data = {
        ...dados,
        registrosExistentes: this.osaExecucaoCustoEquipeDataSource.data
      };

      const modal = this.matDialog.open(
        OsaExecucaoAbaCustosRecursosEquipeCustosFormModalComponent,
        dialogConfig
      );

      modal.afterClosed().subscribe(res => {
        if (res === true) {
          this.carregarCustos(); // atualiza a lista após edição
        }
      });
    } catch (err) {
      Swal.fire({
        toast: true,
        position: 'top-end',
        icon: 'warning',
        text: err.mensagem?.descricao,
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
      });
    }
  }

  excluir(id: number): void {
    Swal.fire({
      title: 'Confirma a exclusão?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sim, excluir',
      cancelButtonText: 'Cancelar'
    }).then(result => {
      if (result.isConfirmed) {
        this.osaExecucaoCustoEquipeService.excluir(id).subscribe(res => {
          if (res.sucesso) {
            this.carregarCustos();
          }
        });
      }
    });
  }

  calcularSubtotal(): number {
    const total = this.osaExecucaoCustoEquipeDataSource.data
      ?.reduce((total, item) => total + (item.custoFinal || 0), 0) || 0;

    this.subtotalChange.emit(total);

    return total;
  }
}
